import React, { useCallback, useEffect, useState } from 'react';
import api from '../core/api';
import BaleConnect from '../pages/compony/BaleConnect';

const isOwner = () => {
  try {
    const s = JSON.parse(localStorage.getItem('user') || 'null');
    return (s?.user || s)?.role === 'owner';
  } catch {
    return false;
  }
};

export default function BaleGuard({ children }) {
  const owner = isOwner();
  const [status, setStatus] = useState(owner ? 'loading' : 'ok'); // loading | required | ok
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (!owner) return;
    api
      .get('/bale')
      .then((r) => setStatus(!r.data.enabled || r.data.connected ? 'ok' : 'required'))
      .catch(() => setStatus('ok')); // خطای شبکه نباید کاربر را قفل کند
  }, [owner]);

  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(() => setToast(null), 3000);
    return () => clearTimeout(t);
  }, [toast]);

  const onMessage = useCallback((text, type = 'success') => setToast({ text, type }), []);
  const onStatus = useCallback((s) => {
    if (s.connected) setStatus('ok');
  }, []);

  const toastEl = toast && (
    <div className={toast.type === 'danger' ? 'toast-danger' : 'toast-success'}>{toast.text}</div>
  );

  if (status === 'loading') return null;

  if (status === 'required') {
    return (
      <>
        {toastEl}
        <div className="card">
          <h2>اتصال به بله الزامی است</h2>
          <p className="section-sub" style={{ margin: 0 }}>
            برای ادامه‌ی کار با پنل، باید حساب بله خود را متصل کنید. بکاپ روزانه‌ی اطلاعات و کد بازیابی رمز عبور از طریق بله برای شما ارسال می‌شود.
          </p>
        </div>
        <BaleConnect autoStart onMessage={onMessage} onStatus={onStatus} />
      </>
    );
  }

  return (
    <>
      {toastEl}
      {children}
    </>
  );
}